import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeStore } from '@core/theme';
import { ImpersonationStore } from '../features/support/impersonation/state/impersonation.store';
import { ImpersonationUsersStore } from '../features/support/impersonation/state/impersonation-users.store';

@Component({
  selector: 'app-authenticated-layout',
  standalone: true,
  imports: [RouterOutlet],
  providers: [ImpersonationStore, ImpersonationUsersStore],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `<router-outlet />`,
})
export class AuthenticatedLayoutComponent {
  private readonly themeStore = inject(ThemeStore);
}
